import {
  DestroyRef,
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
  Service
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AppMeta } from '@core/services/app-meta';

@Service()
export class RouteMeta {
  private readonly router = inject(Router);
  private readonly appMetaService = inject(AppMeta);
  private readonly destroyRef = inject(DestroyRef);

  init(): void {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.applyFromSnapshot());
  }

  // Method gets translation key of description that is set in the deepest child route and applies it as a meta description, if available
  private applyFromSnapshot(): void {
    const deepestRoute = this.findDeepestRoute(this.router.routerState.snapshot.root);
    const descriptionKey = deepestRoute.data?.['metaDescriptionKey'] as string | undefined;
    if (descriptionKey) {
      this.appMetaService.setTranslationDescription(descriptionKey);
    }
  }

  private findDeepestRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    let current = route;
    while (current.firstChild) {
      current = current.firstChild;
    }
    return current;
  }
}

export function provideRouteMeta(): EnvironmentProviders {
  return makeEnvironmentProviders([RouteMeta, provideAppInitializer(() => inject(RouteMeta).init())]);
}
